<template>
  <div class="p-3">
    <div class="text-left">
      <el-card>
        <div slot="header">
          <h4>{{ $tc('products.product', 2) }}</h4>
        </div>
        <LoadingIndicator v-if="isLoading" />
        <div v-else>
          <ProductCartEntry
            v-for="(product, index) in cart.get('products')"
            :key="product.id"
            class="mb-1 py-2 border-bottom"
            :product="product"
            :index="index"
            @removeItem="(index) => onRemoveItem('products', index)"
          />
        </div>
      </el-card>
    </div>
    <div class="text-left mt-3">
      <el-card>
        <div slot="header">
          <h4>{{ $tc('systems.system', 2) }}</h4>
        </div>
        <LoadingIndicator v-if="isLoading" />
        <div v-else>
          <SystemCartEntry
            v-for="(system, index) in cart.get('systems')"
            :key="system.id"
            class="mb-1 py-2 border-bottom"
            :system="system"
            :index="index"
            @removeItem="(index) => onRemoveItem('systems', index)"
          />
        </div>
      </el-card>
      <el-button v-if="isCheckoutAvailable" class="w-100 mt-3 shadow" type="primary" @click="onCheckout">
        {{ $t('checkout.next_to_checkout') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import LoadingIndicator from '../../components/loading/LoadingIndicator';
import ProductCartEntry from './components/ProductCartEntry';
import SystemCartEntry from './components/SystemCartEntry';
export default {
  name: 'CartOverview',
  components: { SystemCartEntry, ProductCartEntry, LoadingIndicator },
  props: {},
  mounted() {
    this.loadCart();
  },
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.CART, ['cart', 'isLoading']),
    isCheckoutAvailable() {
      return this.cart.get('products').length > 0 || this.cart.get('systems').length > 0;
    },
  },
  methods: {
    ...mapActions(StoreModules.CART, ['loadCart', 'removeFromCart']),
    onCheckout() {
      this.$router.push({ name: this.$routeNames.CHECKOUT_MAIN_PAGE_ROUTE });
    },
    async onRemoveItem(type, index) {
      await this.removeFromCart({ type, index });
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
